/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_HintInputs */

const vi_combo_recipe_hint = /** @type {(inputs: Combo_Recipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`💡 Thành phần có thể là sản phẩm đơn vị HOẶC combo cấp thấp hơn.`)
};

/**

* @param {Combo_Recipe_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_hint = /** @type {((inputs?: Combo_Recipe_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_hint(inputs)
});